// src/App.js
import React from 'react';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import LandingPage from './components/LandingPage';
import EnhancedTalentRiskDashboard from './components/EnhancedTalentRiskDashboard';
import InterventionsPage from './components/InterventionsPage';

const App: React.FC = () => {
  return (
    <Router>
      <Routes>
        <Route path="/" element={<LandingPage />} />
        <Route path="/dashboard" element={<EnhancedTalentRiskDashboard />} />
        <Route path="/interventions" element={<InterventionsPage />} />
      </Routes>
    </Router>
  );
};

export default App;